import { BEDSIDE_SHIFT_REPORT, BEDSIDE_SHIFT_REPORT_URL } from "@shared/bedside-shift-report/constants";
import { IActionItem } from "@layout/models/action-item";

export const ActionItems: IActionItem[] = [
    {
        name: BEDSIDE_SHIFT_REPORT,
        icon: "folder-medical",
        url: BEDSIDE_SHIFT_REPORT_URL,
    },
];
